// import store from '@/store'
// 有 name 属性的都是缓存组件
// isPublic 意味着只要登录成功就能看到的页面
import { fetchDetail } from "@/api/epc/income-expense/account";
export default [
  {
    path: "/register",
    component: () => import("@/views/register"),
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/login",
    component: () => import("@/views/login"),
  },
  {
    path: "/pdf-preview",
    component: () => import("@/views/pdf-preview"),
    meta: { isPublic: true },
  },
  {
    path: "/pdf-preview-list",
    component: () => import("@/views/pdf-preview-list"),
    meta: { isPublic: true },
  },
  {
    path: "/internRegister",
    component: () => import("@/views/human-resources/intern/register"),
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/annotation",
    name: "annotation",
    component: () => import("@/views/approval/task/components/annotation"),
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/",
    component: () => import("@/layout"),

    // beforeEnter: (to, from, next) => {

    //   console.log('to', to)
    //   console.log('from', from)

    //   const token = window.localStorage.getItem("token");


    //   if (!token) {
    //     // 未登录直接路由到登录页

    //     if (from.path === "/login") {
    //       next(false);
    //       return;
    //     }
    //     next({
    //       path: "/login",
    //       query: {
    //         redirect: to.fullPath,
    //       },
    //     });
    //     return;

    //   }

    //   if (to.meta.isPublic) {
    //     next();
    //     return;
    //   }
    //   const menuList = window.localStorage.getItem("menuList");
    //   if (menuList) {
    //     const menus = JSON.parse(menuList);
    //     const res = menus.find((item) => item.path === to.path);

    //     console.log('before route check menu', res)

    //     if (res) {
    //       next();
    //     } else {
    //       next("/403");
    //     }
    //   } else {
    //     console.log("local storage don't has menu list");
    //     next("/403");
    //   }
    // },



    children: [
      {
        path: "",
        redirect: "/workplace",
      },
      // 工作台
      {
        path: "workplace",
        component: () => import("@/views/desk"),
        meta: {
          isPublic: true,
        },
      },
      {
        path: "workplace/index-desk",
        component: () => import("@/views/desk/index-desk.vue"),
        meta: {
          isPublic: true,
          noTab: true,
        },
      },
      {
        path: "dataBoard",
        component: () => import("@/views/dataBoard"),
      },
      {
        path: "dataBoard/talent",
        component: () => import("@/views/dataBoard/talent"),
      },
      {
        path: "dataBoard/edit",
        component: () => import("@/views/dataBoard/edit"),
      },
      {
        path: "dataBoard/editMonth",
        component: () => import("@/views/dataBoard/editMonth"),
      },
      {
        path: "dataBoard/bid",
        component: () => import("@/views/dataBoard/bid"),
      },
      {
        path: "dataBoard/bid/add",
        component: () => import("@/views/dataBoard/bidAdd"),
      },
      {
        path: "dataBoard/bid/edit",
        component: () => import("@/views/dataBoard/bidEdit"),
      },
      {
        path: "dataBoard/personDetail",
        component: () => import("@/views/dataBoard/personDetail"),
      },
      {
        path: "dataBoard/money",
        component: () => import("@/views/dataBoard/money/index.vue"),
      },
      {
        path: "dataBoard/money/add",
        component: () => import("@/views/dataBoard/money/add.vue"),
      },
      {
        path: "dataBoard/money/edit",
        component: () => import("@/views/dataBoard/money/edit.vue"),
      },
      {
        path: "dataBoard/talent/edit",
        component: () => import("@/views/dataBoard/talentEdit.vue"),
      },
      // 通讯录
      {
        path: "address-list",
        component: () => import("@/views/address-list"),
        meta: {
          isPublic: true,
        },
      },
      // 消息中心
      {
        path: "/message-center",
        component: () => import("@/views/message-center"),
        meta: {
          isPublic: true,
        },
      },

      // 个人设置页面
      {
        path: "personal-setting",
        component: () => import("@/views/personal/setting"),
        meta: {
          isPublic: true,
        },
      },

      // 新闻管理
      {
        path: "document",
        component: () => import("@/views/document"),
      },
      {
        name: "addDocument",
        path: "document/add",
        component: () => import("@/views/document/add"),
      },
      {
        name: "editDocument",
        path: "document/edit",
        component: () => import("@/views/document/edit"),
      },
      {
        path: "document/detail",
        component: () => import("@/views/document/detail"),
      },

      // 生产管理：合同管理
      {
        name: "contract",
        path: "produce/contract",
        component: () => import("@/views/contract"),
      },
      {
        name: "addContract",
        path: "produce/contract/add",
        component: () => import("@/views/contract/add"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        name: "editContract",
        path: "produce/contract/edit",
        component: () => import("@/views/contract/edit"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        path: "produce/contract-adjust",
        component: () => import("@/views/contract/adjust/index.vue"),
      },
      {
        path: "produce/contract-adjust/add",
        component: () => import("@/views/contract/adjust/add"),
      },
      {
        path: "produce/contract-adjust/detail",
        component: () => import("@/views/contract/adjust/detail"),
      },
      {
        path: "produce/contract/detail",
        component: () => import("@/views/contract/detail"),
      },

      // 合同规模
      {
        path: "produce/contract/scale",
        component: () => import("@/views/contract/scale"),
      },
      // 合同收款项
      {
        path: "produce/contract/collection",
        component: () => import("@/views/contract/collection"),
      },

      //市场管理
      {
        path: "market/channelRegistration",
        component: () => import("@/views/market/channelRegistration/index"),
      },
      {
        path: "market/exclusiveArea",
        component: () => import("@/views/market/exclusiveArea/index"),
      },
      {
        path: "market/exclusiveAreaManagement",
        component: () => import("@/views/market/exclusiveAreaManagement/index"),
      },
      {
        path: "market/projectTrack",
        component: () => import("@/views/market/projectTrack/index"),
      },
      {
        path: "market/projectTrack/add",
        component: () => import("@/views/market/projectTrack/add"),
        meta: { isPublic: true },
      },
      {
        path: "market/projectTrack/edit",
        component: () => import("@/views/market/projectTrack/edit"),
        meta: { isPublic: true },
      },
      {
        path: "market/projectTrack/detail",
        component: () => import("@/views/market/projectTrack/detail"),
        meta: { isPublic: true },
      },
      {
        path: "produce/contract/undertaking/add",
        component: () => import("@/views/contract/undertaking/add"),
      },
      {
        path: "produce/contract/undertaking/edit",
        component: () => import("@/views/contract/undertaking/edit"),
      },

      // 生产管理：进度分配
      {
        name: "progress",
        path: "produce/progress",
        component: () => import("@/views/progress"),
      },
      {
        path: "produce/progress/analysis",
        component: () => import("@/views/progress/analysis/index.vue"),
      },
      {
        name: "progressDetail",
        path: "produce/progress/detail",
        component: () => import("@/views/progress/detail"),
      },
      {
        name: "progressConfig",
        path: "produce/progress/config",
        component: () => import("@/views/progress/config"),
      },

      {
        path: "produce/progress-edit",
        component: () => import("@/views/progress-edit"),
      },


      {
        name: "progressAllocate",
        path: "produce/progress/allocate",
        component: () => import("@/views/progress/allocate"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        name: "progressAllocate2021",
        path: "produce/progress/allocate2021",
        component: () => import("@/views/progress/allocate2021"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        name: "progressAllocate2022",
        path: "produce/progress/allocate2022",
        component: () => import("@/views/progress/allocate2022"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },

      {
        name: "progressallocate2023",
        path: "produce/progress/allocate2023",
        component: () => import("@/views/progress/allocate2023"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        name: "progressallocate2024",
        path: "produce/progress/allocate2024",
        component: () => import("@/views/progress/allocate2024"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        name: "progressallocate2025",
        path: "produce/progress/allocate2025",
        component: () => import("@/views/progress/allocate2025"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        // 专业负责人分配
        name: "majorAllocate",
        path: "produce/progress/major-allocate",
        component: () => import("@/views/progress/major-allocate"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        // 调整阶段产值分配
        name: "adjust-allocate",
        path: "produce/progress/adjust-allocate",
        component: () => import("@/views/progress/adjust-allocate"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },

      {
        // 调整阶段-专业负责人分配
        name: "adjust-major-allocate",
        path: "produce/progress/adjust-major-allocate",
        component: () => import("@/views/progress/adjust-major-allocate"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },

      {
        path: "produce/progress/income-expenditure",
        component: () => import("@/views/progress/income-expenditure"),
      },

      {
        path: "produce/progress/edit-progress",
        component: () => import("@/views/progress/edit-progress"),
      },

      // 计划填报
      {
        path: "produce/progress/plan",
        component: () => import("@/views/progress/plan"),
      },
      {
        path: "produce/progress/plan/detail",
        component: () => import("@/views/progress/plan/detail"),
      },
      {
        path: "produce/progress/plan/confirm",
        component: () => import("@/views/progress/plan/confirm"),
      },
      {
        path: "produce/progress/plan/edit",
        component: () => import("@/views/progress/plan/edit"),
      },

      {
        path: "produce/progress/plan/year",
        component: () => import("@/views/progress/plan/year"),
      },
      {
        path: "produce/progress/plan/month",
        component: () => import("@/views/progress/plan/month"),
      },
      {
        path: "produce/progress/projectFin",
        component: () => import("@/views/progress/projectFin"),
      },
      {
        path: "produce/progress/projectFin/detail",
        component: () => import("@/views/progress/projectFin/detail"),
      },
      {
        path: "produce/progress/projectFin/add",
        component: () => import("@/views/progress/projectFin/add"),
      },
      {
        path: "produce/progress/projectFin/edit",
        component: () => import("@/views/progress/projectFin/edit"),
      },
      //
      {
        path: "produce/progress/projectFinBranch",
        component: () => import("@/views/progress/projectFinBranch"),
      },
      {
        path: "produce/progress/projectFinBranch/detail",
        component: () => import("@/views/progress/projectFinBranch/detail"),
      },
      {
        path: "produce/progress/projectFinBranch/add",
        component: () => import("@/views/progress/projectFinBranch/add"),
      },
      {
        path: "produce/progress/projectFinBranch/edit",
        component: () => import("@/views/progress/projectFinBranch/edit"),
      },
      {
        path: "produce/progress/subPay",
        component: () => import("@/views/progress/subPay"),
      },
      {
        path: "produce/progress/subPay/detail",
        component: () => import("@/views/progress/subPay/detail"),
      },
      {
        path: "produce/progress/subPay/add",
        component: () => import("@/views/progress/subPay/add"),
      },
      {
        path: "produce/progress/subPay/edit",
        component: () => import("@/views/progress/subPay/edit"),
      },
      {
        name: "contractStatusOverview",
        path: "produce/progress/contractStatus",
        component: () => import("@/views/progress/contractStatus"),
      },
      {
        path: "produce/progress/contractStatus/detail",
        component: () => import("@/views/progress/contractStatus/detail"),
      },
      {
        path: "produce/progress/contractStatus/edit",
        component: () => import("@/views/progress/contractStatus/edit"),
      },
      {
        name: "overview",
        path: "produce/overview",
        component: () => import("@/views/progress/overview"),
      },
      {
        path: "produce/overview/detail",
        component: () => import("@/views/progress/overview/detail"),
      },
      {
        name: "editProject",
        path: "produce/overview/edit",
        component: () => import("@/views/progress/overview/edit"),
      },
      // 合同登记
      {
        name: "contract-register",
        path: "produce/contractRegister/review",
        component: () => import("@/views/contract-register"),
      },
      {
        name: "addContractRegister",
        path: "produce/contractRegister/review/add",
        component: () => import("@/views/contract-register/add"),
      },
      {
        name: "signContractRegister",
        path: "produce/contractRegister/review/sign",
        component: () => import("@/views/contract-register/sign"),
      },
      {
        path: "produce/contractRegister/review/detail",
        component: () => import("@/views/contract-register/detail"),
      },

      // 分包登记
      {
        name: "subpackage-register",
        path: "produce/contractRegister/subpackage",
        component: () => import("@/views/subpackage-register"),
      },
      {
        name: "addSubpackageRegister",
        path: "produce/contractRegister/subpackage/add",
        component: () => import("@/views/subpackage-register/add"),
      },
      {
        name: "signSubpackageRegister",
        path: "produce/contractRegister/subpackage/sign",
        component: () => import("@/views/subpackage-register/sign"),
      },
      {
        path: "produce/contractRegister/subpackage/detail",
        component: () => import("@/views/subpackage-register/detail"),
      },

      // 分支(分院)分包登记
      {
        name: "branch-subpackage-register",
        path: "produce/contractRegister/branchSubpackage",
        component: () => import("@/views/branch-subpackage-register"),
        meta: { isPublic: true, title: "分支机构外部采购合同审批表" },
      },
      {
        name: "addBranchSubpackageRegister",
        path: "produce/contractRegister/branchSubpackage/add",
        component: () => import("@/views/branch-subpackage-register/add"),
        meta: { isPublic: true, title: "分支机构外部采购合同审批" },
      },
      {
        name: "signBranchSubpackageRegister",
        path: "produce/contractRegister/branchSubpackage/sign",
        component: () => import("@/views/branch-subpackage-register/sign"),
        meta: { isPublic: true, title: "分支机构外部采购类合同归档" },
      },
      {
        path: "produce/contractRegister/branchSubpackage/detail",
        component: () => import("@/views/branch-subpackage-register/detail"),
        meta: { isPublic: true, title: "分支机构外部采购类合同详情" },
      },

      // 框架类合同登记
      {
        name: "framework-contract-register",
        path: "produce/contractRegister/framework",
        component: () => import("@/views/framework-contract-register"),
      },
      {
        name: "addFrameworkContractRegister",
        path: "produce/contractRegister/framework/add",
        component: () => import("@/views/framework-contract-register/add"),
      },
      {
        path: "produce/contractRegister/framework/detail",
        component: () => import("@/views/framework-contract-register/detail"),
      },
      {
        name: "signFrameworkContractRegister",
        path: "produce/contractRegister/framework/sign",
        component: () => import("@/views/framework-contract-register/sign"),
      },

      // 财务管理：发票管理
      {
        name: "invoice",
        path: "finance/invoice",
        component: () => import("@/views/invoice"),
      },
      {
        name: "applyInvoice",
        path: "finance/invoice/apply",
        component: () => import("@/views/invoice/apply"),
      },
      {
        name: "editInvoice",
        path: "finance/invoice/edit",
        component: () => import("@/views/invoice/edit"),
      },
      {
        path: "finance/invoice/detail",
        component: () => import("@/views/invoice/detail"),
      },
      {
        name: "sharedCost",
        path: "finance/shared-cost",
        component: () => import("@/views/shared-cost"),
      },
      {
        path: "finance/shared-cost/project-detail",
        component: () => import("@/views/shared-cost/project-detail"),
      },
      {
        name: "standingBook",
        path: "finance/standing-book",
        component: () => import("@/views/finance/standing-book"),
      },
      {
        name: "subpackage",
        path: "finance/subpackage",
        component: () => import("@/views/finance/subpackage"),
      },

      // 财务流水管理
      {
        path: "finance/transaction",
        redirect: "finance/transaction/basic-data",
      },
      {
        path: "finance/transaction/basic-data",
        component: () => import("@/views/finance/transaction/basic-data"),
      },
      {
        path: "finance/transaction/detail",
        component: () => import("@/views/finance/transaction/detail"),
      },
      {
        path: "finance/transaction/detail/bill-form",
        component: () => import("@/views/finance/transaction/detail/bill-form"),
      },
      {
        path: "finance/transaction/detail/bill-detail",
        component: () => import("@/views/finance/transaction/detail/bill-detail"),
      },
      {
        path: "finance/transaction/detail/bill-use",
        component: () => import("@/views/finance/transaction/detail/bill-use"),
      },
      {
        name: "transactionClaim",
        path: "finance/transaction/claim",
        component: () => import("@/views/finance/transaction/claim"),
      },
      {
        name: "transactionClaimApply",
        path: "finance/transaction/claim/apply",
        component: () => import("@/views/finance/transaction/claim/claim"),
      },
      {
        name: "transactionClaimDetail",
        path: "finance/transaction/claim/detail",
        component: () => import("@/views/finance/transaction/claim/detail"),
      },
      {
        name: "transactionClaimBatch",
        path: "finance/transaction/claim/batch",
        component: () => import("@/views/finance/transaction/claim/batch"),
      },
      {
        name: "subpackagePaymentList",
        path: "finance/transaction/subpackage-payment/list",
        component: () => import("@/views/finance/transaction/subpackage-payment/list"),
      },
      {
        name: "subpackagePaymentMainInstitute",
        path: "finance/transaction/subpackage-payment/main-institute",
        component: () => import("@/views/finance/transaction/subpackage-payment/main-institute"),
      },
      {
        name: "subpackagePaymentBranchInstitute",
        path: "finance/transaction/subpackage-payment/branch-institute",
        component: () => import("@/views/finance/transaction/subpackage-payment/branch-institute"),
      },

      // 应收账款
      {
        name: "accounts-receivable",
        path: "finance/accounts-receivable",
        component: () => import("@/views/finance/accounts-receivable"),
      },
      {
        path: "finance/accounts-receivable/detail",
        component: () => import("@/views/finance/accounts-receivable/detail"),
      },
      // 合同资产
      {
        name: "contract-assets",
        path: "finance/contract-assets",
        component: () => import("@/views/finance/contract-assets"),
      },
      {
        path: "finance/contract-assets/detail",
        component: () => import("@/views/finance/contract-assets/detail"),
      },

      // 合同进度管理
      {
        name: "contract-progress",
        path: "finance/contract-progress",
        component: () => import("@/views/finance/contract-progress"),
      },



      // 财务测算（26年减值预测）
      {
        name: "finimpairment-import",
        path: "finance/finimpairment/import",
        component: () => import("@/views/finance/finimpairment/import/index"),
      },
      // 期初数据：合同资产 / 应收账款 合并页（a-tabs 切换）
      {
        name: "finimpairment-initial",
        path: "finance/finimpairment/initial",
        component: () => import("@/views/finance/finimpairment/initial/index"),
      },
      {
        name: "finimpairment-nc-balance",
        path: "finance/finimpairment/nc-balance",
        component: () => import("@/views/finance/finimpairment/nc-balance/index"),
      },
      {
        name: "finimpairment-collection",
        path: "finance/finimpairment/collection",
        component: () => import("@/views/finance/finimpairment/collection/index"),
      },
      {
        name: "finimpairment-revenue",
        path: "finance/finimpairment/revenue",
        component: () => import("@/views/finance/finimpairment/revenue/index"),
      },
      {
        name: "finimpairment-config",
        path: "finance/finimpairment/config",
        component: () => import("@/views/finance/finimpairment/config/index"),
      },
      {
        name: "finimpairment-summary",
        path: "finance/finimpairment/summary",
        component: () => import("@/views/finance/finimpairment/summary/index"),
      },



      // 产值进度月报
      {
        name: "progress-report",
        path: "finance/progress-report",
        component: () => import("@/views/finance/progress-report"),
      },
      {
        name: "progress-report-detail",
        path: "finance/progress-report/detail",
        component: () => import("@/views/finance/progress-report/detail"),
      },
      // 项目回款计划
      {
        path: "finance/project-payment-plan",
        component: () => import("@/views/finance/project-payment-plan/index"),
      },
      {
        path: "finance/project-payment-plan/fill",
        component: () => import("@/views/finance/project-payment-plan/fill"),
      },
      {
        path: "finance/project-payment-plan/summary",
        component: () => import("@/views/finance/project-payment-plan/summary"),
      },
      // 分包付款计划
      {
        path: "finance/subpackage-payment-plan",
        component: () => import("@/views/finance/subpackage-payment-plan/index"),
      },
      {
        path: "finance/subpackage-payment-plan/fill",
        component: () => import("@/views/finance/subpackage-payment-plan/fill"),
      },
      {
        path: "finance/subpackage-payment-plan/summary",
        component: () => import("@/views/finance/subpackage-payment-plan/summary"),
      },

      // 人力资源：员工管理
      {
        name: "employee",
        path: "human-resources/map/employee",
        component: () => import("@/views/human-resources/employee"),
      },
      {
        name: "addEmployee",
        path: "human-resources/map/employee/add",
        component: () => import("@/views/human-resources/employee/add"),
      },
      {
        name: "editEmployee",
        path: "human-resources/map/employee/edit",
        component: () => import("@/views/human-resources/employee/edit"),
      },

      {
        path: "human-resources/map/employee/detail",
        component: () => import("@/views/human-resources/employee/detail"),
      },
      {
        path: "human-resources/map/employee/transfer",
        component: () => import("@/views/human-resources/employee/transfer"),
      },
      // 人力资源：标签管理
      {
        name: "tag",
        path: "human-resources/map/tag",
        component: () => import("@/views/human-resources/tag"),
      },
      {
        name: "addTag",
        path: "human-resources/map/tag/add",
        component: () => import("@/views/human-resources/tag/add"),
      },
      {
        name: "editTag",
        path: "human-resources/map/tag/edit",
        component: () => import("@/views/human-resources/tag/edit"),
      },
      // 人力资源：员工标签管理
      {
        name: "employeeTag",
        path: "human-resources/map/employeeTag",
        component: () => import("@/views/human-resources/employeeTag"),
      },
      {
        // 考勤打卡
        path: "human-resources/clock",
        component: () => import("@/views/human-resources/clock"),
      },
      {
        // 请假/公出/出差/出差变更/加班
        path: "human-resources/clock/add",
        component: () => import("@/views/human-resources/clock/add"),
      },
      // 补卡
      {
        path: "human-resources/clock/replace",
        component: () => import("@/views/human-resources/clock/replace"),
      },

      // 考勤管理
      {
        path: "human-resources/timecard/list",
        component: () => import("@/views/human-resources/timecard/index"),
      },
      // 考勤配置
      {
        path: "human-resources/timecard/config",
        component: () => import("@/views/human-resources/timecard/config"),
      },
      // 异常考勤统计
      {
        path: "human-resources/timecard/abnormal",
        component: () => import("@/views/human-resources/timecard/abnormal"),
      },
      // 加班统计
      {
        path: "human-resources/timecard/overtime",
        component: () => import("@/views/human-resources/timecard/overtime"),
      },

      // 出入统计
      {
        path: "human-resources/timecard/access",
        component: () => import("@/views/human-resources/timecard/pass"),
      },
      {
        path: "human-resources/timecard/record",
        component: () => import("@/views/human-resources/timecard/record"),
      },
      {
        path: "human-resources/timecard/record2",
        component: () => import("@/views/human-resources/timecard/record2"),
      },
      // 请假/出差/公出查询
      {
        path: "human-resources/timecard/holiday",
        component: () => import("@/views/human-resources/timecard/holiday"),
      },

      {
        path: "human-resources/salary",
        component: () => import("@/views/human-resources/salary"),
      },
      {
        path: "human-resources/performance",
        component: () => import("@/views/human-resources/performance"),
      },

      {
        path: "human-resources/intern",
        component: () => import("@/views/human-resources/intern"),
      },
      {
        path: "human-resources/intern/add",
        component: () => import("@/views/human-resources/intern/add"),
      },
      {
        path: "human-resources/intern/edit",
        component: () => import("@/views/human-resources/intern/edit"),
      },
      {
        path: "human-resources/intern/detail",
        component: () => import("@/views/human-resources/intern/detail"),
      },
      {
        path: "human-resources/leave",
        component: () => import("@/views/human-resources/leave"),
      },
      {
        path: "human-resources/leave/add",
        component: () => import("@/views/human-resources/leave/add"),
      },
      {
        // 面试管理
        name: "recruit",
        path: "human-resources/recruit",
        component: () => import("@/views/recruit"),
      },
      {
        name: "addRecruit",
        path: "human-resources/recruit/add",
        component: () => import("@/views/recruit/add"),
      },
      {
        name: "editRecruit",
        path: "human-resources/recruit/edit",
        component: () => import("@/views/recruit/edit"),
      },
      {
        path: "human-resources/recruit/invite-hr",
        component: () => import("@/views/recruit/invite-hr"),
      },
      {
        path: "human-resources/recruit/resume",
        component: () => import("@/views/recruit/resume"),
      },

      {
        // name: 'humanResourcesOrg',
        path: "human-resources/map/org",
        component: () => import("@/views/human-resources/org"),
      },
      {
        name: "humanResourcesOrgAdd",
        path: "human-resources/map/org/add",
        component: () => import("@/views/human-resources/org/add"),
      },
      {
        name: "humanResourcesOrgEdit",
        path: "human-resources/map/org/edit",
        component: () => import("@/views/human-resources/org/edit"),
      },
      {
        path: "human-resources/map/org/detail",
        component: () => import("@/views/human-resources/org/detail"),
      },
      {
        path: "human-resources/map/org/group-detail",
        component: () => import("@/views/human-resources/org/group-detail"),
      },
      {
        path: "human-resources/map/org/honor",
        component: () => import("@/views/human-resources/org/honor"),
      },
      {
        path: "human-resources/map/org/group-list",
        component: () => import("@/views/human-resources/org/group-list"),
      },
      // 人力资源：分支机构员工瓴云账号信息填写表
      {
        name: "addBranchEmployeeAccount",
        path: "human-resources/hr/branch/employee/add",
        component: () =>
          import("@/views/human-resources/hr/branch/employee/add"),
      },

      // 综合办公：物料管理
      {
        path: "oa/material/index",
        component: () => import("@/views/oa/material"),
      },
      {
        name: "addMaterial",
        path: "oa/material/index/add",
        component: () => import("@/views/oa/material/add"),
      },
      {
        name: "addMaterial",
        path: "oa/material/index/addStorage",
        component: () => import("@/views/oa/material/addStorage"),
      },
      {
        path: "oa/material/index/edit",
        component: () => import("@/views/oa/material/edit"),
      },
      {
        path: "oa/material/apply",
        component: () => import("@/views/oa/material/apply"),
      },
      {
        name: "materialList",
        path: "oa/material/list",
        component: () => import("@/views/oa/material/list"),
      },
      {
        name: "materialDetail",
        path: "oa/material/list/detail",
        component: () => import("@/views/oa/material/detail"),
      },
      // 综合办公：招待费申请
      {
        path: "oa/entertain/apply",
        component: () => import("@/views/oa/entertain/apply"),
      },
      {
        name: "entertainList",
        path: "oa/entertain/list",
        component: () => import("@/views/oa/entertain/list"),
      },
      {
        name: "approvedEntertainList",
        path: "oa/entertain/approvedList",
        component: () => import("@/views/oa/entertain/approvedList"),
      },
      // 综合办公：固定资产台账
      {
        path: "oa/fixedAssets/apply",
        component: () => import("@/views/oa/fixedAssetsBook/apply"),
      },
      //固定资产报废
      {
        path: "oa/fixedAssets/scrap/0",
        component: () => import("@/views/oa/fixedAssetsBook/scrap"),
      },
      {
        path: "oa/fixedAssets/scrap/1",
        component: () => import("@/views/oa/fixedAssetsBook/scrap"),
      },
      {
        path: "oa/fixedAssets/handleScrap",
        component: () => import("@/views/oa/fixedAssetsBook/handleScrap"),
      },
      {
        path: "oa/fixedAssetsBook/handover",
        component: () => import("@/views/oa/fixedAssetsBook/handover"),
      },
      {
        path: "oa/fixedAssetsBook",
        component: () => import("@/views/oa/fixedAssetsBook"),
      },
      {
        path: "oa/fixedAssetsBook/detail",
        component: () => import("@/views/oa/fixedAssetsBook/detail"),
      },
      {
        path: "oa/fixedAssetsBook/add",
        component: () => import("@/views/oa/fixedAssetsBook/add"),
      },
      {
        path: "oa/fixedAssetsBook/edit",
        component: () => import("@/views/oa/fixedAssetsBook/edit"),
      },
      // 综合办公：固定资产管理
      {
        path: "oa/fixedAssetsCategory",
        component: () => import("@/views/oa/fixedAssetsCategory"),
      },
      {
        path: "oa/fixedAssetsCategory/add",
        component: () => import("@/views/oa/fixedAssetsCategory/add"),
      },
      {
        path: "oa/fixedAssetsCategory/edit",
        component: () => import("@/views/oa/fixedAssetsCategory/edit"),
      },
      //固定资产盘点
      {
        path: "oa/fixedAssetsInventory",
        component: () => import("@/views/oa/fixedAssetsInventory"),
      },
      {
        path: "oa/fixedAssetsInventory/add",
        component: () => import("@/views/oa/fixedAssetsInventory/add"),
      },
      {
        path: "oa/fixedAssetsInventory/edit",
        component: () => import("@/views/oa/fixedAssetsInventory/edit"),
      },
      {
        path: "oa/fixedAssetsInventory/manage",
        component: () => import("@/views/oa/fixedAssetsInventory/manage"),
      },
      // 综合办公：物资品类管理
      {
        path: "oa/purchaseMaterials",
        component: () => import("@/views/oa/purchaseMaterials"),
      },
      {
        path: "oa/purchaseMaterials/add",
        component: () => import("@/views/oa/purchaseMaterials/add"),
      },
      {
        path: "oa/purchaseMaterials/edit",
        component: () => import("@/views/oa/purchaseMaterials/edit"),
      },
      {
        path: "oa/purchaseMaterials/apply",
        component: () => import("@/views/oa/purchaseMaterials/apply"),
      },
      {
        path: "oa/purchaseMaterials/office-apply",
        meta: { isPublic: true, title: "重新提交采购申请" },
        component: () => import("@/views/oa/purchaseMaterials/office-apply"),
      },
      {
        path: "oa/purchaseMaterialsRecord/edit",
        meta: { isPublic: true, title: "重新提交物资采购记录" },
        component: () => import("@/views/oa/purchaseMaterialsRecord/edit"),
      },
      {
        path: "oa/purchaseMaterialsList",
        component: () => import("@/views/oa/purchaseMaterials/list"),
      },
      {
        name: "materialListDepartment",
        path: "oa/purchaseMaterialsList/department",
        component: () => import("@/views/oa/purchaseMaterials/department"),
      },
      // 综合办公：物资采购记录
      {
        path: "oa/purchaseMaterialsRecord",
        component: () => import("@/views/oa/purchaseMaterialsRecord"),
      },
      {
        path: "oa/purchaseMaterialsRecord/add",
        component: () => import("@/views/oa/purchaseMaterialsRecord/add"),
      },
      // 综合办公：工单管理
      {
        path: "oa/workOrder/mine",
        component: () => import("@/views/oa/workOrder/mine"),
      },
      {
        path: "oa/workOrder/pending",
        component: () => import("@/views/oa/workOrder/pending"),
      },
      {
        path: "oa/workOrder/processed",
        component: () => import("@/views/oa/workOrder/processed"),
      },
      {
        path: "oa/workOrder/add",
        component: () => import("@/views/oa/workOrder/add"),
        // 表单页不在菜单表中，加 isPublic 后路由跳转时自动生成"新建工单"标签页
        meta: { isPublic: true, title: "新建工单" },
      },
      {
        path: "oa/workOrder/edit",
        component: () => import("@/views/oa/workOrder/edit"),
        meta: { isPublic: true, title: "更新工单" },
      },
      {
        path: "oa/workOrder/detail",
        component: () => import("@/views/oa/workOrder/detail"),
        meta: { isPublic: true, title: "工单详情" },
      },
      {
        path: "oa/workOrder/config",
        component: () => import("@/views/oa/workOrder/config"),
      },
      // 综合办公：礼品管理
      {
        path: "oa/gift/index",
        component: () => import("@/views/oa/gift"),
      },
      {
        name: "addGift",
        path: "oa/gift/index/add",
        component: () => import("@/views/oa/gift/add"),
      },
      {
        name: "addGift",
        path: "oa/gift/index/addStorage",
        component: () => import("@/views/oa/gift/addStorage"),
      },
      {
        path: "oa/gift/index/edit",
        component: () => import("@/views/oa/gift/edit"),
      },
      {
        path: "oa/gift/apply",
        component: () => import("@/views/oa/gift/apply"),
      },
      {
        name: "giftList",
        path: "oa/gift/list",
        component: () => import("@/views/oa/gift/list"),
      },
      {
        name: "giftDetail",
        path: "oa/gift/list/detail",
        component: () => import("@/views/oa/gift/detail"),
      },
      {
        name: "giftRecord",
        path: "oa/gift/record",
        component: () => import("@/views/oa/gift/record"),
      },

      // 公告管理
      {
        path: "oa/notice",
        component: () => import("@/views/oa/notice"),
      },
      {
        path: "oa/notice/detail",
        component: () => import("@/views/oa/notice/detail"),
      },
      {
        name: "addNotice",
        path: "oa/notice/add",
        component: () => import("@/views/oa/notice/add"),
      },
      {
        name: "editNotice",
        path: "oa/notice/edit",
        component: () => import("@/views/oa/notice/edit"),
      },

      // 员工天地管理
      {
        path: "oa/staffCulture",
        component: () => import("@/views/oa/staffCulture"),
      },
      {
        path: "oa/staffCulture/detail",
        component: () => import("@/views/oa/staffCulture/detail"),
      },
      {
        name: "addStaffCulture",
        path: "oa/staffCulture/add",
        component: () => import("@/views/oa/staffCulture/add"),
      },
      {
        name: "editStaffCulture",
        path: "oa/staffCulture/edit",
        component: () => import("@/views/oa/staffCulture/edit"),
      },
      
      // 质量安全管理
      {
        path: "oa/quality",
        component: () => import("@/views/oa/quality"),
      },
      {
        path: "oa/quality/detail",
        component: () => import("@/views/oa/quality/detail"),
      },
      {
        name: "addQuality",
        path: "oa/quality/add",
        component: () => import("@/views/oa/quality/add"),
      },
      {
        name: "editQuality",
        path: "oa/quality/edit",
        component: () => import("@/views/oa/quality/edit"),
      },
      // 综合办公：督办管理
      {
        name: "supervise",
        path: "oa/supervise",
        component: () => import("@/views/supervise"),
      },
      {
        name: "addSupervise",
        path: "oa/supervise/add",
        component: () => import("@/views/supervise/add"),
      },
      {
        path: "oa/supervise/detail",
        component: () => import("@/views/supervise/detail"),
      },

      // 综合办公：会议管理
      {
        name: "meeting",
        path: "oa/meeting",
        component: () => import("@/views/meeting"),
      },
      {
        name: "addMeeting",
        path: "oa/meeting/add",
        component: () => import("@/views/meeting/add"),
      },
      {
        name: "editMeeting",
        path: "oa/meeting/edit",
        component: () => import("@/views/meeting/edit"),
      },
      {
        name: "detailMeeting",
        path: "oa/meeting/detail",
        component: () => import("@/views/meeting/detail"),
      },
      {
        name: "handlingMeeting",
        path: "oa/meeting/handling",
        component: () => import("@/views/meeting/handling"),
      },
      // 综合办公：邮件管理
      {
        name: "meeting",
        path: "oa/mail",
        component: () => import("@/views/mail"),
      },
      // 待办事项
      {
        name: "todoList",
        path: "todo",
        component: () => import("@/views/todo/index"),
        meta: {
          isPublic: true,
          title: "待办事项",
        },
      },
      // 审批：审批任务和起草中心
      {
        path: "approval/center",
        component: () => import("@/views/approval/center"),
      },
      {
        name: "approvalTask",
        path: "approval/task",
        component: () => import("@/views/approval/task"),
      },
      {

        path: "approval/task/transfer",
        component: () => import("@/views/approval/task/transfer"),
      },
      {
        name: "approvalTaskDetail",
        path: "approval/task/detail",
        component: () => import("@/views/approval/task/detail"),
      },
      // 设计校审详情
      {
        path: "design-audit/detail/:id",
        component: () => import("@/views/approval/task/components/audit/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新签章
      {
        path: "stamp-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_stamp_review/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新会签评审
      {
        path: "prj-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_prj_review/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新申请任务通知单
      {
        path: "notice-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_prj_task_notice/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交招标管理
      {
        path: "bidding-reapply/:id",
        component: () => import("@/views/approval/task/components/bidding/form/edit-bidding"),
        meta: {
          isPublic: true,
        },
      },

      // 重新提交评标
      {
        path: "evaluation-reapply/:id",
        component: () => import("@/views/approval/task/components/bidding/form/edit-evaluation"),
        meta: {
          isPublic: true,
        },
      },

      // 重新提交中标公示
      {
        path: "winbid-reapply/:id",
        component: () => import("@/views/approval/task/components/bidding/form/edit-publicity"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计方案修编
      {
        path: "plan-revise-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_plan_revise/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计输入需求
      {
        path: "design-input-req-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_input_req/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计计划
      {
        path: "design-plan-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_plan/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交简易项目
      {
        path: "simple-plan-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_plan_simple/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计会签
      {
        path: "countersign-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_countersign/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新申请出版打印
      {
        path: "print-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_stamp_print/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计确认
      {
        path: "affirm-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_affirm/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交服务报告
      {
        path: "design-service-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_service/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计变更
      {
        path: "design-change-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_change/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交蓝图替换
      {
        path: "blueprint-replace-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_blueprint_replace/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交简单设计计划
      {
        path: "design-plan-simple-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_plan_simple/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交竣工报告
      {
        path: "completion-report-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_completion_report/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交专业提资
      {
        path: "major-transfer-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_major_transfer/review"),
        meta: {
          isPublic: true,
        },
      },
      // 重新提交设计评审
      {
        path: "review-reapply/:id",
        component: () => import("@/views/approval/task/components/cosys_design_review/review"),
        meta: {
          isPublic: true,
        },
      },
      {
        path: "project-filing/:id",
        component: () => import("@/views/approval/task/components/cosys_project_filing/review"),
        meta: {
          isPublic: true,
        },
      },
      {
        path: "project-bid-apply/:id",
        component: () => import("@/views/approval/task/components/cosys_project_bid_apply/review"),
        meta: {
          isPublic: true,
        },
      },
      {
        path: "oa-leave/:id",
        component: () => import("@/views/approval/task/components/human-resources/oa_leave/review"),
        meta: {
          isPublic: true,
        },
      },
      {
        path: "hr-branch-employee/:id",
        component: () => import("@/views/approval/task/components/human-resources/hr-branch-employee/review"),
        meta: {
          isPublic: true,
        },
      },

      // 综合办公，兼容原来的路径，目的是原来的书签还能用
      {
        path: "oa/approval",
        redirect: "approval/task",
      },
      {
        path: "oa/approval/detail",
        redirect: "approval/task/detail",
      },

      {
        path: "oa/doc",
        component: () => import("@/views/oa/doc"),
      },
      {
        name: "addDoc",
        path: "oa/doc/add",
        component: () => import("@/views/oa/doc/add"),
      },

      {
        path: "/oa/archive/query",
        component: () => import("@/views/archives/index"),
      },
      {
        path: "/oa/archive/query/lend",
        component: () => import("@/views/archives/lend"),
      },
      {
        path: "/oa/archive/query/transfer",
        component: () => import("@/views/archives/transfer"),
      },
      {
        path: "/oa/archive/query/detail",
        component: () => import("@/views/archives/detail"),
      },
      {
        path: "/oa/archive/account",
        component: () => import("@/views/archives/list"),
      },
      {
        path: "/oa/archive/account/add",
        component: () => import("@/views/archives/add"),
      },
      {
        path: "/oa/archive/account/edit",
        component: () => import("@/views/archives/edit"),
      },

      {
        path: "/oa/meal",
        component: () => import("@/views/oa/meal"),
      },
      {
        path: "/oa/meal/add",
        component: () => import("@/views/oa/meal/add"),
      },
      {
        path: "/oa/meal/add-overtime",
        component: () => import("@/views/oa/meal/add-overtime"),
      },
      {
        path: "/oa/meal-card",
        component: () => import("@/views/oa/meal-card"),
      },
      {
        path: "/oa/meal-card/apply",
        component: () => import("@/views/oa/meal-card/apply"),
      },

      {
        path: "/oa/face",
        component: () => import("@/views/oa/face"),
      },
      {
        path: "/oa/car",
        component: () => import("@/views/oa/car"),
      },
      {
        path: "/oa/ca/apply",
        component: () => import("@/views/oa/ca/apply"),
      },
      // 系统设置
      {
        path: "setting/module",
        component: () => import("@/views/setting/module"),
      },
      {
        name: "addModule",
        path: "setting/module/add",
        component: () => import("@/views/setting/module/add"),
      },
      {
        name: "editModule",
        path: "setting/module/edit",
        component: () => import("@/views/setting/module/edit"),
      },
      {
        path: "setting/permission",
        component: () => import("@/views/setting/permission"),
      },
      {
        name: "addPermission",
        path: "setting/permission/add",
        component: () => import("@/views/setting/permission/add"),
      },
      {
        name: "editPermission",
        path: "setting/permission/edit",
        component: () => import("@/views/setting/permission/edit"),
      },

      {
        path: "setting/menu",
        component: () => import("@/views/setting/menu"),
      },
      {
        name: "addMenu",
        path: "setting/menu/add",
        component: () => import("@/views/setting/menu/add"),
      },
      {
        name: "editMenu",
        path: "setting/menu/edit",
        component: () => import("@/views/setting/menu/edit"),
      },

      {
        path: "setting/role",
        component: () => import("@/views/setting/role"),
      },
      {
        name: "addRole",
        path: "setting/role/add",
        component: () => import("@/views/setting/role/add"),
      },
      {
        name: "editRole",
        path: "setting/role/edit",
        component: () => import("@/views/setting/role/edit"),
      },

      {
        path: "setting/user",
        component: () => import("@/views/setting/user"),
      },
      {
        name: "addUser",
        path: "setting/user/add",
        component: () => import("@/views/setting/user/add"),
      },
      {
        name: "editUser",
        path: "setting/user/edit",
        component: () => import("@/views/setting/user/edit"),
      },

      {
        path: "setting/auth",
        component: () => import("@/views/setting/auth"),
      },
      {
        path: "setting/data-dict",
        component: () => import("@/views/setting/data-dict"),
      },
      {
        name: "addDataDict",
        path: "setting/data-dict/add",
        component: () => import("@/views/setting/data-dict/add"),
      },
      {
        name: "editDataDict",
        path: "setting/data-dict/edit",
        component: () => import("@/views/setting/data-dict/edit"),
      },
      {
        path: "setting/company",
        component: () => import("@/views/setting/company"),
      },
      {
        name: "addCompany",
        path: "setting/company/add",
        component: () => import("@/views/setting/company/add"),
      },
      {
        name: "editCompany",
        path: "setting/company/edit",
        component: () => import("@/views/setting/company/edit"),
      },
      {
        path: "setting/supplier",
        component: () => import("@/views/setting/supplier"),
      },
      {
        name: "addSupplier",
        path: "setting/supplier/add",
        component: () => import("@/views/setting/supplier/add"),
      },
      {
        name: "editSupplier",
        path: "setting/supplier/edit",
        component: () => import("@/views/setting/supplier/edit"),
      },
      {
        path: "setting/area",
        component: () => import("@/views/setting/area"),
      },
      {
        name: "addArea",
        path: "setting/area/add",
        component: () => import("@/views/setting/area/add"),
      },
      {
        name: "editArea",
        path: "setting/area/edit",
        component: () => import("@/views/setting/area/edit"),
      },

      {
        path: "setting/meeting-room",
        component: () => import("@/views/setting/meeting-room"),
      },
      {
        name: "addMeetingRoom",
        path: "setting/meeting-room/add",
        component: () => import("@/views/setting/meeting-room/add"),
      },
      {
        name: "editMeetingRoom",
        path: "setting/meeting-room/edit",
        component: () => import("@/views/setting/meeting-room/edit"),
      },

      {
        path: "setting/app-version",
        component: () => import("@/views/setting/app-version"),
      },
      {
        name: "addAppVersion",
        path: "setting/app-version/add",
        component: () => import("@/views/setting/app-version/add"),
      },

      {
        path: "setting/ai-version",
        component: () => import("@/views/setting/ai-version"),
      },
      {
        path: "setting/ai-version/add",
        component: () => import("@/views/setting/ai-version/add"),
      },
      {
        path: "setting/ai-version/edit",
        component: () => import("@/views/setting/ai-version/edit"),
      },

      {
        path: "setting/api-log",
        component: () => import("@/views/setting/api-log"),
      },
      {
        path: "setting/log",
        component: () => import("@/views/setting/log"),
      },
      {
        path: "setting/face",
        component: () => import("@/views/setting/face"),
      },
      {
        path: "setting/approval",
        component: () => import("@/views/setting/approval"),
      },

      {
        path: "bidding/company",
        redirect: "market/bidding/company",
      },
      {
        path: "market/bidding/company",
        component: () => import("@/views/bidding/company"),
      },
      {
        path: "bidding/company/detail",
        redirect: "market/bidding/company/detail",
      },
      {
        path: "market/bidding/company/detail",
        component: () => import("@/views/bidding/company/detail"),
      },
      {
        path: "market/bidding/company/view",
        component: () => import("@/views/bidding/company/view"),
      },
      {
        path: "bidding/index",
        redirect: "market/bidding/index",
      },
      {
        path: "market/bidding/index",
        component: () => import("@/views/bidding"),
      },
      {
        path: "bidding/index/add",
        redirect: "market/bidding/index/add",
      },
      {
        name: "addBidding",
        path: "market/bidding/index/add",
        component: () => import("@/views/bidding/add"),
      },
      {
        path: "bidding/index/edit",
        redirect: "market/bidding/index/edit",
      },
      {
        name: "editBidding",
        path: "market/bidding/index/edit",
        component: () => import("@/views/bidding/edit"),
      },
      {
        path: "bidding/index/detail",
        redirect: "market/bidding/index/detail",
      },
      {
        path: "market/bidding/index/detail",
        component: () => import("@/views/bidding/detail"),
      },
      {
        path: "bidding/index/evaluation/select-user",
        redirect: "market/bidding/index/evaluation/select-user",
      },
      {
        path: "market/bidding/index/evaluation/select-user",
        component: () => import("@/views/bidding/evaluation/select-user"),
      },
      {
        path: "bidding/index/evaluation",
        redirect: "market/bidding/index/evaluation",
      },
      {
        path: "market/bidding/index/evaluation",
        component: () => import("@/views/bidding/evaluation/jury-evaluation"),
      },
      {
        path: "bidding/index/evaluation/view",
        redirect: "market/bidding/index/evaluation/view",
      },
      {
        path: "market/bidding/index/evaluation/view",
        component: () => import("@/views/bidding/evaluation/view"),
      },
      {
        path: "bidding/index/evaluation/summary",
        redirect: "market/bidding/index/evaluation/summary",
      },
      {
        path: "market/bidding/index/evaluation/summary",
        component: () => import("@/views/bidding/evaluation/summary"),
      },
      {
        path: "bidding/index/publicity",
        redirect: "market/bidding/index/publicity",
      },
      {
        path: "market/bidding/index/publicity",
        component: () => import("@/views/bidding/publicity"),
      },
      {
        path: "bidding/article",
        redirect: "market/bidding/article",
      },
      {
        path: "market/bidding/article",
        component: () => import("@/views/bidding/article"),
      },
      {
        path: "bidding/article/add",
        redirect: "market/bidding/article/add",
      },
      {
        name: "addBiddingArticle",
        path: "market/bidding/article/add",
        component: () => import("@/views/bidding/article/add"),
      },
      {
        path: "bidding/article/edit",
        redirect: "market/bidding/article/edit",
      },
      {
        name: "editBiddingArticle",
        path: "market/bidding/article/edit",
        component: () => import("@/views/bidding/article/edit"),
      },

      // 项目备案
      {
        path: "market/projectFiling",
        component: () => import("@/views/market/projectFiling/index"),
      },
      {
        path: "market/projectFiling/add",
        component: () => import("@/views/market/projectFiling/add"),
      },
      {
        path: "market/projectFiling/detail",
        component: () => import("@/views/market/projectFiling/detail"),
      },
      {
        path: "market/projectFiling/follow",
        component: () => import("@/views/market/projectFiling/follow"),
        meta: { isPublic: true },
      },
      // 项目管理
      {
        path: "market/project",
        component: () => import("@/views/market/project/index"),
      },
      {
        path: "market/project/detail",
        component: () => import("@/views/market/project/detail"),
        meta: { isPublic: true },
      },

      // 通用分享页面
      {
        path: "share",
        component: () => import("@/views/share"),
        meta: {
          isPublic: true,
        },
      },

      // 参数化系统
      // 公共参数配置页面
      {
        path: "lab/parameterization/public-params",
        component: () => import("@/views/parameterization/public-params"),
      },
      // 计算书
      {
        path: "lab/parameterization/book",
        component: () => import("@/views/parameterization/book"),
      },
      {
        name: "addParamBook",
        path: "lab/parameterization/book/add",
        component: () => import("@/views/parameterization/book/add"),
      },
      {
        name: "editParamBook",
        path: "lab/parameterization/book/edit",
        component: () => import("@/views/parameterization/book/edit"),
      },
      {
        name: "paramBookDetail",
        path: "lab/parameterization/book/detail",
        component: () => import("@/views/parameterization/book/detail"),
      },

      {
        path: "lab/parameterization/task",
        component: () => import("@/views/parameterization/task"),
      },
      {
        path: "lab/parameterization/task/select",
        component: () => import("@/views/parameterization/task/select"),
      },
      {
        name: "addParamTask",
        path: "lab/parameterization/task/add",
        component: () => import("@/views/parameterization/task/add"),
      },
      {
        path: "lab/parameterization/task/detail",
        component: () => import("@/views/parameterization/task/detail"),
      },

      // 官网管理
      {
        path: "website/news",
        redirect: 'oa/website/news'
      },
      {
        path: "oa/website/news",
        component: () => import("@/views/website/news"),
      },
      {
        path: "website/news/add",
        redirect: 'oa/website/news/add'
      },
      {
        name: "websiteNewsAdd",
        path: "oa/website/news/add",
        component: () => import("@/views/website/news/add"),
      },
      {
        path: "website/news/edit",
        redirect: 'oa/website/news/edit'
      },
      {
        name: "websiteNewsEdit",
        path: "oa/website/news/edit",
        component: () => import("@/views/website/news/edit"),
      },
      {
        path: "website/case",
        redirect: 'oa/website/case'
      },
      {
        path: "oa/website/case",
        component: () => import("@/views/website/case"),
      },
      {
        path: "website/case/add",
        redirect: 'oa/website/case/add'
      },
      {
        name: "websiteCaseAdd",
        path: "oa/website/case/add",
        component: () => import("@/views/website/case/add"),
      },
      {
        path: "website/case/edit",
        redirect: 'oa/website/case/edit'
      },
      {
        name: "websiteCaseEdit",
        path: "oa/website/case/edit",
        component: () => import("@/views/website/case/edit"),
      },
      {
        path: "website/job",
        redirect: 'oa/website/job'
      },
      {
        path: "oa/website/job",
        component: () => import("@/views/website/job"),
      },
      {
        path: "website/job/add",
        redirect: 'oa/website/job/add'
      },
      {
        name: "websiteJobAdd",
        path: "oa/website/job/add",
        component: () => import("@/views/website/job/add"),
      },
      {
        path: "website/job/edit",
        redirect: 'oa/website/job/edit'
      },
      {
        name: "websiteJobEdit",
        path: "oa/website/job/edit",
        component: () => import("@/views/website/job/edit"),
      },
      {
        path: "website/feedback",
        redirect: 'oa/website/feedback'
      },
      {
        path: "oa/website/feedback",
        component: () => import("@/views/website/feedback"),
      },
      // epc项目
      {
        path: "epc/project",
        component: () => import("@/views/epc/project"),
      },
      {
        path: "epc/project/add",
        name: "projAdd",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/project/add"),
      },
      {
        path: "epc/project/update",
        name: "projUpdate",
        component: () => import("@/views/epc/project/edit"),
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
      },
      {
        path: "epc/project/detail",
        name: "epcDetail",
        component: () => import("@/views/epc/project/detail"),
      },
      {
        path: "epc/project/budget",
        name: "projBudegt",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/project/budget"),
      },
      {
        path: "epc/project/view",
        component: () => import("@/views/epc/project/view"),
      },
      {
        path: "epc/project/mainContractAssign",
        name: "purchaseMCA",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/project/main-contract-assign"),
      },
      {
        path: "epc/project/mainContractImplement",
        name: "purchaseMain",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/project/main-contract-implement"),
      },

      // 策划阶段
      {
        path: "epc/plan/manageObjective",
        name: "planManObj",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/plan/manageObjective"),
      },
      {
        path: "epc/plan/managePlan",
        name: "planManPlan",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/plan/manage-plan"),
      },
      {
        path: "epc/plan/constructionSchedule",
        name: "planConstru",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/plan/construction-schedule"),
      },
      {
        path: "epc/plan/budget",
        name: "planBudget",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/plan/budget/index"),
      },
      // 设计阶段
      {
        path: "epc/design/ChangeApproval",
        name: "designChange",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/design/ChangeApproval"),
      },
      {
        path: "epc/design/ResultConfirm",
        name: "designRes",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/design/ResultConfirm"),
      },
      {
        path: "epc/design/DisclosureReport",
        name: "designDis",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/design/DisclosureManual"),
      },
      {
        path: "epc/design/CompletionReport",
        name: "designCom",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/design/CompletionReport"),
      },
      // 施工阶段
      {
        path: "epc/construction/organizeDesign",
        name: "construOrg",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/organize-design"),
      },
      {
        path: "epc/construction/commenceReview",
        name: "construCom",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/commence-review"),
      },
      {
        path: "epc/construction/process",
        name: "construPro",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/process"),
      },
      {
        path: "epc/construction/qualityInspect",
        name: "construQua",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/quality-inspect"),
      },
      {
        path: "epc/construction/safety",
        name: "construSaf",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/safety"),
      },
      {
        path: "epc/construction/dataInspect",
        name: "construData",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/data-inspect"),
      },
      {
        path: "epc/construction/claim",
        name: "construClaim",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/claim"),
      },
      {
        path: "epc/construction/visa",
        name: "construcVisa",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/visa"),
      },
      {
        path: "epc/construction/accident",
        name: "construAcci",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/accident"),
      },
      {
        path: "epc/construction/violation",
        name: "ConstruVio",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/construction/violation"),
      },
      // 采购阶段
      {
        path: "epc/purchase/masterPlan",
        name: "purchaseMaster",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/master-plan"),
      },
      {
        path: "epc/purchase/bidding",
        name: "purchaseBid",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/bidding"),
      },
      {
        path: "epc/purchase/singleSource",
        name: "purchaseSing",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/single-source"),
      },
      {
        path: "epc/purchase/inquiry",
        name: "purchaseInq",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/inquiry"),
      },
      {
        path: "epc/purchase/emergancyPurchase",
        name: "purchaseEmergan",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/emergancy-purchase"),
      },
      {
        path: "epc/purchase/transfer",
        name: "purchaseTransfer",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/transfer"),
      },
      {
        path: "epc/purchase/returnToFactory",
        name: "purchaseReturn",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/return-to-factory"),
      },
      {
        path: "epc/purchase/subpackageContract",
        name: "purchaseSub",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/purchase/subpackage-contract"),
      },
      // 收支阶段
      {
        path: "epc/incomeExpense/capital",
        name: "incExpCap",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/income-expense/capital"),
        beforeEnter: (to, from, next) => {
          if (to.query.activeKey === "0") {
            //若进入收支台账页面
            fetchDetail({ pid: to.query.pid }).then((res) => {
              console.log(res);
              if (res && res?.code === 400) {
                next(false);
                return;
              } else {
                next();
              }
            });
          } else {
            next();
          }
          // next(false)   next();  next('/403')
        },
      },
      {
        path: "epc/incomeExpense/completeSettlement",
        name: "incExpComSettle",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () =>
          import("@/views/epc/income-expense/complete-settlement"),
      },
      {
        path: "epc/incomeExpense/subpackageSettlement",
        name: "incExpSub",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () =>
          import("@/views/epc/income-expense/subpackage-settlement"),
      },
      {
        path: "epc/incomeExpense/costExecutionReport",
        name: "incExpCost",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () =>
          import("@/views/epc/income-expense/cost-execution-report"),
      },
      {
        path: "epc/incomeExpense/surplusMaterialDisposal",
        name: "incExpSur",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () =>
          import("@/views/epc/income-expense/surplus-material-disposal"),
      },
      // 收尾阶段
      {
        path: "epc/complete/end",
        name: "completeEnd",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/complete/end"),
      },
      {
        path: "epc/complete/performanceAssessment",
        name: "completePer",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/complete/performance-assessment"),
      },
      {
        path: "epc/complete/report",
        name: "completeReport",
        meta: {
          alertWhenLeaving: true, // 关闭网页时需要提示
        },
        component: () => import("@/views/epc/complete/report"),
      },

      // epc 项目汇总
      {
        name: 'epcProjectSummary',
        path: "epc/project-summary",
        component: () => import("@/views/epc/project-summary"),
      },
      {
        path: "epc/project-summary/add",
        component: () => import("@/views/epc/project-summary/add"),
      },
      {
        path: "epc/project-summary/edit",
        component: () => import("@/views/epc/project-summary/edit"),
      },
      {
        path: "epc/project-summary/detail",
        component: () => import("@/views/epc/project-summary/detail"),
      },

      // 财务核算
      {
        path: "epc/financial-accounting",
        component: () => import("@/views/epc/financial-accounting"),
      },
      // 业务核算
      {
        path: "epc/business-accounting",
        component: () => import("@/views/epc/business-accounting"),
      },



      // epc利润管理
      {
        path: "epc/profit",
        component: () => import("@/views/epc/profit"),
      },
      {
        name: 'epc_profit_edit',
        path: "epc/profit/edit",
        component: () => import("@/views/epc/profit/edit"),
      },
      {
        path: "epc/profit/detail",
        component: () => import("@/views/epc/profit/detail"),
      },

      // epc进度管理
      {
        path: "epc/process",
        component: () => import("@/views/epc/process"),
      },
      {
        path: "epc/process/plan-fill",
        component: () => import("@/views/epc/process/plan-fill"),
      },
      {
        path: "epc/process/plan-management",
        component: () => import("@/views/epc/process/plan-management"),
      },

      // 课程管理
      {
        path: "knowledge/course",
        component: () => import("@/views/knowledge/course"),
      },
      {
        name: 'courseAdd',
        path: "knowledge/course/add",
        component: () => import("@/views/knowledge/course/add"),
      },
      {
        name: 'courseEdit',
        path: "knowledge/course/edit",
        component: () => import("@/views/knowledge/course/edit"),
      },

      // 目录管理
      {
        path: "knowledge/directory",
        component: () => import("@/views/knowledge/directory"),
      },

      // 课程列表（用户查询）
      {
        name: 'study',
        path: "knowledge/study",
        component: () => import("@/views/knowledge/study"),
      },
      // 我的课程/考试/收藏
      {
        path: "knowledge/study/me",
        component: () => import("@/views/knowledge/study/me"),
      },
      // 我的课程/考试/收藏详情
      {
        path: "knowledge/study/detail",
        component: () => import("@/views/knowledge/study/detail"),
      },
      // 正在学习页面
      {
        path: "knowledge/study/play",
        component: () => import("@/views/knowledge/study/play"),
      },
      //打分
      {
        path: "score/index",
        component: () => import("@/views/score"),
      },
      {
        path: "score/index/detail",
        component: () => import("@/views/score/detail"),
      },
      {
        path: "score/index/edit",
        component: () => import("@/views/score/edit"),
      },
      {
        path: "score/index/score",
        component: () => import("@/views/score/score"),
      },
      // 考试中心
      {
        path: "knowledge/exam/index",
        component: () => import("@/views/exam"),
      },
      {
        name: "addExam",
        path: "knowledge/exam/index/add",
        component: () => import("@/views/exam/add"),
      },
      {
        name: "editExam",
        path: "knowledge/exam/index/edit",
        component: () => import("@/views/exam/edit"),
      },
      {
        name: "startExam",
        path: "knowledge/exam/index/start",
        component: () => import("@/views/exam/start"),
      },

      {
        path: "knowledge/exam/management",
        component: () => import("@/views/exam/management"),
      },
      {
        path: "knowledge/exam/management/review",
        component: () => import("@/views/exam/review"),
      },

      {
        path: "knowledge/in",
        redirect: "knowledge/lib/in",
      },
      {
        name: "inKnowledge",
        path: "knowledge/lib/in",
        component: () => import("@/views/knowledge/in"),
      },
      {
        path: "knowledge/in/add",
        redirect: "knowledge/lib/in/add",
      },
      {
        name: "addKnowledge",
        path: "knowledge/lib/in/add",
        component: () => import("@/views/knowledge/in/add"),
      },
      {
        name: "addBrand",
        path: "knowledge/lib/in/add-brand",
        component: () => import("@/views/knowledge/in/add-brand"),
      },
      {
        name: "addProduction",
        path: "knowledge/lib/in/add-production",
        component: () => import("@/views/knowledge/in/add-production"),
      },
      {
        path: "knowledge/in/edit",
        redirect: "knowledge/lib/in/edit",
      },
      {
        name: "editKnowledge",
        path: "knowledge/lib/in/edit",
        component: () => import("@/views/knowledge/in/edit"),
      },
      {
        name: "editBrand",
        path: "knowledge/lib/in/edit-brand",
        component: () => import("@/views/knowledge/in/edit-brand"),
      },
      {
        name: "editProduction",
        path: "knowledge/lib/in/edit-production",
        component: () => import("@/views/knowledge/in/edit-production"),
      },
      {
        path: "knowledge/in/detail",
        redirect: "knowledge/lib/in/detail",
      },
      {
        path: "knowledge/lib/in/detail",
        component: () => import("@/views/knowledge/in/detail"),
      },


      {
        name: "think",
        path: "knowledge/lib/think",
        component: () => import("@/views/knowledge/think"),
      },
      {
        name: "thinkAdd",
        path: "knowledge/lib/think/add",
        component: () => import("@/views/knowledge/think/add"),
      },
      {
        name: "thinkEdit",
        path: "knowledge/lib/think/edit",
        component: () => import("@/views/knowledge/think/edit"),
      },
      {
        path: "knowledge/lib/think/preview",
        component: () => import("@/views/knowledge/think/preview"),
      },

      {
        path: "knowledge/lib/out",
        component: () => import("@/views/knowledge/out"),
      },

      {
        path: "knowledge/resource",
        component: () => import("@/views/knowledge/resource"),
      },
      {
        path: "knowledge/aiResource",
        component: () => import("@/views/knowledge/aiResource"),
      },
      {
        path: "knowledge/aiResource/add1",
        component: () => import("@/views/knowledge/aiResource/add1"),
      },
      {
        path: "knowledge/aiResource/edit1",
        component: () => import("@/views/knowledge/aiResource/edit1"),
      },
      {
        path: "knowledge/aiResource/add2",
        component: () => import("@/views/knowledge/aiResource/add2"),
      },
      {
        path: "knowledge/aiResource/edit2",
        component: () => import("@/views/knowledge/aiResource/edit2"),
      },
      {
        path: "knowledge/resource/add",
        component: () => import("@/views/knowledge/resource/add"),
      },
      {
        path: "knowledge/resource/detail",
        component: () => import("@/views/knowledge/resource/detail"),
      },
      {
        path: "party/public/notice",
        component: () => import("@/views/party/notice"),
      },
      {
        name: "addPartyNotice",
        path: "party/public/notice/add",
        component: () => import("@/views/party/notice/add"),
      },

      {
        name: "editPartyNotice",
        path: "party/public/notice/edit",
        component: () => import("@/views/party/notice/edit"),
      },

      {
        path: "party/public/notice/detail",
        component: () => import("@/views/party/notice/detail"),
      },
      {
        path: "party/public/honest",
        component: () => import("@/views/party/honest"),
      },
      {
        name: "addPartyHonest",
        path: "party/public/honest/add",
        component: () => import("@/views/party/honest/add"),
      },

      {
        name: "editPartyHonest",
        path: "party/public/honest/edit",
        component: () => import("@/views/party/honest/edit"),
      },

      {
        path: "party/public/honest/detail",
        component: () => import("@/views/party/honest/detail"),
      },


      {
        path: "party/public/letter",
        component: () => import("@/views/party/letter"),
      },
      {
        path: "party/public/letter/add",
        component: () => import("@/views/party/letter/add"),
      },
      {
        path: "party/public/letter/detail",
        component: () => import("@/views/party/letter/detail"),
      },

      {
        path: "technical-quality/score",
        component: () => import("@/views/technical-quality/score"),
      },
      {
        name: "technicalQualityScoreAdd",
        path: "technical-quality/score/add",
        component: () => import("@/views/technical-quality/score/add"),
      },
      {
        name: "technicalQualityScoreEdit",
        path: "technical-quality/score/edit",
        component: () => import("@/views/technical-quality/score/edit"),
      },
      {
        path: "technical-quality/score/detail",
        component: () => import("@/views/technical-quality/score/detail"),
      },
      {

        path: "technical-quality/report",
        component: () => import("@/views/technical-quality/report"),
      },
      {
        path: "technical-quality/report/add",
        component: () => import("@/views/technical-quality/report/add"),
      },
      {
        path: "technical-quality/report/edit",
        component: () => import("@/views/technical-quality/report/edit"),
      },
      {
        path: "technical-quality/report/history",
        component: () => import("@/views/technical-quality/report/history"),
      },
      {
        path: "technical-quality/report/detail",
        component: () => import("@/views/technical-quality/report/detail"),
      },

      {
        path: "technical-quality/report/table",
        component: () => import("@/views/technical-quality/report/table"),
      },


      {
        path: "technical-quality/security-check-management/security-check",
        component: () => import("@/views/technical-quality/security-check"),
      },
      {
        path: "technical-quality/security-check-management/security-check/add",
        component: () => import("@/views/technical-quality/security-check/add"),
      },
      {
        path: "technical-quality/security-check-management/security-check/detail",
        component: () => import("@/views/technical-quality/security-check/detail"),
      },

      {
        path: "technical-quality/security-check-management/security-check/book",
        component: () => import("@/views/technical-quality/security-check/book"),
      },

      {
        path: "technical-quality/security-check-management/security-check/book/edit",
        component: () => import("@/views/technical-quality/security-check/book/edit"),
      },
      {
        path: "technical-quality/security-check-management/security-check/project",
        component: () => import("@/views/technical-quality/security-check/project"),
      },

      {
        path: "technical-quality/security-check-management/security-check/duty",
        component: () => import("@/views/technical-quality/security-check/duty"),
      },

      {
        path: "technical-quality/emergency/drill",
        component: () => import("@/views/technical-quality/emergency/drill"),
      },

      {
        path: "technical-quality/accident/list",
        component: () => import("@/views/technical-quality/accident/list"),
      },
      {
        name: 'accidentAdd',
        path: "technical-quality/accident/list/add",
        component: () => import("@/views/technical-quality/accident/list/add"),
      },
      {
        name: 'accidentEdit',
        path: "technical-quality/accident/list/edit",
        component: () => import("@/views/technical-quality/accident/list/edit"),
      },
      {
        path: "technical-quality/accident/list/detail",
        component: () => import("@/views/technical-quality/accident/list/detail"),
      },

      {
        path: "technical-quality/accident/standing-book",
        component: () => import("@/views/technical-quality/accident/standing-book"),
      },
      {
        path: "technical-quality/quality-import/budget-list",
        component: () => import("@/views/technical-quality/quality-import/budget-list"),
      },
      {
        path: "technical-quality/quality-import/budget-list/add",
        component: () => import("@/views/technical-quality/quality-import/budget-list/add"),
      },
      {
        path: "technical-quality/quality-import/budget-list/edit",
        component: () => import("@/views/technical-quality/quality-import/budget-list/edit"),
      },
      {
        path: "technical-quality/quality-import/budget-list/detail",
        component: () => import("@/views/technical-quality/quality-import/budget-list/detail"),
      },
      {
        path: "technical-quality/quality-import/money-list",
        component: () => import("@/views/technical-quality/quality-import/money-list"),
      },
      {
        path: "technical-quality/quality-import/money-list/add",
        component: () => import("@/views/technical-quality/quality-import/money-list/add"),
      },
      {
        path: "technical-quality/quality-import/money-list/edit",
        component: () => import("@/views/technical-quality/quality-import/money-list/edit"),
      },
      {
        path: "technical-quality/quality-import/money-list/detail",
        component: () => import("@/views/technical-quality/quality-import/money-list/detail"),
      },
      {
        path: "technical-quality/safeProduction",
        component: () => import("@/views/technical-quality/safeProduction"),
      },
      {
        path: "technical-quality/safeProduction/list",
        component: () => import("@/views/technical-quality/safeProduction/list"),
      },
      {
        path: "technical-quality/riskManagement/estimate",
        component: () => import("@/views/technical-quality/riskManagement/estimate"),
      },
      {
        path: "technical-quality/riskManagement/estimate/edit",
        component: () => import("@/views/technical-quality/riskManagement/estimate/edit"),
      },
      {
        path: "technical-quality/riskManagement/estimate/detail",
        component: () => import("@/views/technical-quality/riskManagement/estimate/detail"),
      },

      {
        path: "technical-quality/safeDailyWork/meeting",
        component: () => import("@/views/technical-quality/safeDailyWork/meeting"),
      },
      {
        path: "technical-quality/safeDailyWork/meeting/add",
        component: () => import("@/views/technical-quality/safeDailyWork/meeting/add"),
      },
      {
        path: "technical-quality/safeDailyWork/meeting/edit",
        component: () => import("@/views/technical-quality/safeDailyWork/meeting/edit"),
      },
      {
        path: "technical-quality/safeDailyWork/meeting/detail",
        component: () => import("@/views/technical-quality/safeDailyWork/meeting/detail"),
      },
      {
        path: "technical-quality/safeDailyWork/issue",
        component: () => import("@/views/technical-quality/safeDailyWork/issue"),
      },
      {
        path: "technical-quality/safeDailyWork/issue/add",
        component: () => import("@/views/technical-quality/safeDailyWork/issue/add"),
      },
      {
        path: "technical-quality/safeDailyWork/issue/edit",
        component: () => import("@/views/technical-quality/safeDailyWork/issue/edit"),
      },
      {
        path: "technical-quality/safeDailyWork/issue/detail",
        component: () => import("@/views/technical-quality/safeDailyWork/issue/detail"),
      },
      {
        path: "technical-quality/safeDailyWork/duty",
        component: () => import("@/views/technical-quality/safeDailyWork/duty"),
      },
      {
        path: "technical-quality/safeDailyWork/duty/add",
        component: () => import("@/views/technical-quality/safeDailyWork/duty/add"),
      },
      {
        path: "technical-quality/safeDailyWork/duty/edit",
        component: () => import("@/views/technical-quality/safeDailyWork/duty/edit"),
      },
      {
        path: "technical-quality/safeDailyWork/duty/detail",
        component: () => import("@/views/technical-quality/safeDailyWork/duty/detail"),
      },
      {
        path: "technical-quality/riskManagement/task",
        component: () => import("@/views/technical-quality/riskManagement/task"),
      },
      {
        path: "technical-quality/riskManagement/task/add",
        component: () => import("@/views/technical-quality/riskManagement/task/add"),
      },
      {
        path: "technical-quality/riskManagement/task/edit",
        component: () => import("@/views/technical-quality/riskManagement/task/edit"),
      },
      {
        path: "technical-quality/riskManagement/task/detail",
        component: () => import("@/views/technical-quality/riskManagement/task/detail"),
      },
      {
        path: "technical-quality/riskManagement/task/list",
        component: () => import("@/views/technical-quality/riskManagement/task/list"),
      },
      {
        path: "lab/ai/log",
        component: () => import("@/views/ai/log.vue"),
      },

      {
        path: "collaborate",
        component: () => import("@/views/collaborate/index.vue"),
      },

      {
        path: "chatgpt",
        component: () => import("@/views/chatgpt/index.vue"),
      },

      {
        path: "test",
        component: () => import("@/views/test/index.vue"),
        meta: {
          isPublic: true,
        }
      },


      {
        path: "403",
        component: () => import("@/views/403"),
        meta: {
          isPublic: true,
        },
      },
      {
        path: "*",
        component: () => import("@/views/404"),
        meta: {
          isPublic: true,
        },
      },
    ],
  },
];
